import { useEffect } from 'react';

function typeKey(type) {
  return Array.isArray(type) ? type.slice().sort().join(',') : type;
}

// Injects a <script type="application/ld+json"> into <head> and removes it on
// unmount / data change, so each page contributes exactly its own structured
// data. Google reads JSON-LD from the rendered DOM, so client-side is fine —
// except the SEO shell (backend/server.py) already server-renders the exact
// same @type into the initial HTML for bots/no-JS. Without this, hydration
// left both copies in the DOM (duplicate Product/BreadcrumbList/FAQPage on
// activity pages, duplicate Organization/WebSite on every page). Removing any
// existing script of the same @type before appending lets the client version
// take over cleanly, whether the duplicate came from the server shell or a
// previous render of this same component.
export default function JsonLd({ data }) {
  const serialized = data ? JSON.stringify(data) : '';
  useEffect(() => {
    if (!serialized) return undefined;
    const ownType = typeKey(JSON.parse(serialized)['@type']);
    document.head.querySelectorAll('script[type="application/ld+json"]').forEach((el) => {
      try {
        if (typeKey(JSON.parse(el.textContent)['@type']) === ownType) el.remove();
      } catch {
        // malformed/foreign script — leave it alone
      }
    });
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-owa-jsonld', '');
    script.text = serialized;
    document.head.appendChild(script);
    return () => script.remove();
  }, [serialized]);

  return null;
}
